// This file is auto-generated. Do not edit manually.
// Run "npm run -w packages/iconik-api generate" to regenerate.
/** biome-ignore-all lint/complexity/noBannedTypes: some API definitions are unclear */
import { httpMethod } from '../constants';
import type { IconikApiHeaders } from '../types';

export const UsersHttpGetGroups = 'UsersHttpGetGroups' as const;
export const UsersHttpPostGroups = 'UsersHttpPostGroups' as const;
export const UsersHttpGetGroupsAllBasic = 'UsersHttpGetGroupsAllBasic' as const;
export const UsersHttpGetGroupsBasic = 'UsersHttpGetGroupsBasic' as const;
export const UsersHttpGetGroupsMappings = 'UsersHttpGetGroupsMappings' as const;
export const UsersHttpPostGroupsMappings =
  'UsersHttpPostGroupsMappings' as const;
export const UsersHttpDeleteGroupsMappingsByName =
  'UsersHttpDeleteGroupsMappingsByName' as const;
export const UsersHttpGetGroupsMappingsByName =
  'UsersHttpGetGroupsMappingsByName' as const;
export const UsersHttpDeleteGroupsByGroupId =
  'UsersHttpDeleteGroupsByGroupId' as const;
export const UsersHttpGetGroupsByGroupId =
  'UsersHttpGetGroupsByGroupId' as const;
export const UsersHttpPatchGroupsByGroupId =
  'UsersHttpPatchGroupsByGroupId' as const;
export const UsersHttpPutGroupsByGroupId =
  'UsersHttpPutGroupsByGroupId' as const;
export const UsersHttpDeleteGroupsByGroupIdLogo =
  'UsersHttpDeleteGroupsByGroupIdLogo' as const;
export const UsersHttpPostGroupsByGroupIdLogo =
  'UsersHttpPostGroupsByGroupIdLogo' as const;
export const UsersHttpPostGroupsByGroupIdReindex =
  'UsersHttpPostGroupsByGroupIdReindex' as const;
export const UsersHttpDeleteGroupsByGroupIdUsersByUserId =
  'UsersHttpDeleteGroupsByGroupIdUsersByUserId' as const;
export const UsersHttpPostGroupsByGroupIdUsersByUserId =
  'UsersHttpPostGroupsByGroupIdUsersByUserId' as const;
export const UsersHttpGetRoleGroups = 'UsersHttpGetRoleGroups' as const;
export const UsersHttpPostRoleGroups = 'UsersHttpPostRoleGroups' as const;
export const UsersHttpGetRoleGroupsBasic =
  'UsersHttpGetRoleGroupsBasic' as const;
export const UsersHttpDeleteRoleGroupsByGroupId =
  'UsersHttpDeleteRoleGroupsByGroupId' as const;
export const UsersHttpGetRoleGroupsByGroupId =
  'UsersHttpGetRoleGroupsByGroupId' as const;
export const UsersHttpPatchRoleGroupsByGroupId =
  'UsersHttpPatchRoleGroupsByGroupId' as const;
export const UsersHttpPutRoleGroupsByGroupId =
  'UsersHttpPutRoleGroupsByGroupId' as const;
export const UsersHttpDeleteRoleGroupsByGroupIdUsersByUserId =
  'UsersHttpDeleteRoleGroupsByGroupIdUsersByUserId' as const;
export const UsersHttpPostRoleGroupsByGroupIdUsersByUserId =
  'UsersHttpPostRoleGroupsByGroupIdUsersByUserId' as const;
export const UsersHttpGetTeams = 'UsersHttpGetTeams' as const;
export const UsersHttpPostTeams = 'UsersHttpPostTeams' as const;
export const UsersHttpGetTeamsBasic = 'UsersHttpGetTeamsBasic' as const;
export const UsersHttpDeleteTeamsByTeamId =
  'UsersHttpDeleteTeamsByTeamId' as const;
export const UsersHttpGetTeamsByTeamId = 'UsersHttpGetTeamsByTeamId' as const;
export const UsersHttpPatchTeamsByTeamId =
  'UsersHttpPatchTeamsByTeamId' as const;
export const UsersHttpPutTeamsByTeamId = 'UsersHttpPutTeamsByTeamId' as const;
export const UsersHttpDeleteTeamsByTeamIdLogo =
  'UsersHttpDeleteTeamsByTeamIdLogo' as const;
export const UsersHttpPostTeamsByTeamIdLogo =
  'UsersHttpPostTeamsByTeamIdLogo' as const;
export const UsersHttpDeleteTeamsByTeamIdUsersByUserId =
  'UsersHttpDeleteTeamsByTeamIdUsersByUserId' as const;
export const UsersHttpPostTeamsByTeamIdUsersByUserId =
  'UsersHttpPostTeamsByTeamIdUsersByUserId' as const;
export const UsersHttpGetUsers = 'UsersHttpGetUsers' as const;
export const UsersHttpPostUsers = 'UsersHttpPostUsers' as const;
export const UsersHttpGetUsersBasic = 'UsersHttpGetUsersBasic' as const;
export const UsersHttpGetUsersCurrent = 'UsersHttpGetUsersCurrent' as const;
export const UsersHttpPatchUsersCurrent = 'UsersHttpPatchUsersCurrent' as const;
export const UsersHttpPutUsersCurrent = 'UsersHttpPutUsersCurrent' as const;
export const UsersHttpGetUsersCurrentOtpConfigure =
  'UsersHttpGetUsersCurrentOtpConfigure' as const;
export const UsersHttpPostUsersCurrentOtpConfigure =
  'UsersHttpPostUsersCurrentOtpConfigure' as const;
export const UsersHttpPutUsersCurrentOtpConfigure =
  'UsersHttpPutUsersCurrentOtpConfigure' as const;
export const UsersHttpDeleteUsersCurrentPhoto =
  'UsersHttpDeleteUsersCurrentPhoto' as const;
export const UsersHttpPostUsersCurrentPhoto =
  'UsersHttpPostUsersCurrentPhoto' as const;
export const UsersHttpGetUsersCurrentRoles =
  'UsersHttpGetUsersCurrentRoles' as const;
export const UsersHttpDeleteUsersCurrentTotpConfigure =
  'UsersHttpDeleteUsersCurrentTotpConfigure' as const;
export const UsersHttpPostUsersCurrentTotpConfigure =
  'UsersHttpPostUsersCurrentTotpConfigure' as const;
export const UsersHttpPostUsersCurrentTotpValidateConfiguration =
  'UsersHttpPostUsersCurrentTotpValidateConfiguration' as const;
export const UsersHttpDeleteUsersInvitePurge =
  'UsersHttpDeleteUsersInvitePurge' as const;
export const UsersHttpPostUsersInviteRegister =
  'UsersHttpPostUsersInviteRegister' as const;
export const UsersHttpPostUsersInviteTokenRequest =
  'UsersHttpPostUsersInviteTokenRequest' as const;
export const UsersHttpPostUsersInviteValidate =
  'UsersHttpPostUsersInviteValidate' as const;
export const UsersHttpDeleteUsersPartnerDomainAccess =
  'UsersHttpDeleteUsersPartnerDomainAccess' as const;
export const UsersHttpPostUsersPartnerDomainAccess =
  'UsersHttpPostUsersPartnerDomainAccess' as const;
export const UsersHttpDeleteUsersByUserId =
  'UsersHttpDeleteUsersByUserId' as const;
export const UsersHttpGetUsersByUserId = 'UsersHttpGetUsersByUserId' as const;
export const UsersHttpPatchUsersByUserId =
  'UsersHttpPatchUsersByUserId' as const;
export const UsersHttpPutUsersByUserId = 'UsersHttpPutUsersByUserId' as const;
export const UsersHttpDeleteUsersByUserIdPhoto =
  'UsersHttpDeleteUsersByUserIdPhoto' as const;
export const UsersHttpPostUsersByUserIdPhoto =
  'UsersHttpPostUsersByUserIdPhoto' as const;
export const UsersHttpPostUsersByUserIdReindex =
  'UsersHttpPostUsersByUserIdReindex' as const;
export const UsersHttpGetUsersByUserIdRoles =
  'UsersHttpGetUsersByUserIdRoles' as const;
export const UsersHttpGetUsersByUserIdRolesByRole =
  'UsersHttpGetUsersByUserIdRolesByRole' as const;
export const UsersHttpDeleteUsersByUserIdSaml =
  'UsersHttpDeleteUsersByUserIdSaml' as const;
export const UsersHttpPutUsersByUserIdSaml =
  'UsersHttpPutUsersByUserIdSaml' as const;
export const UsersHttpGetRoles = 'UsersHttpGetRoles' as const;

/**
 * Original schema `BaseQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-BaseQueryParamsSchema}
 */
export interface UsersBaseQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `DomainUsersByEmailSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-DomainUsersByEmailSchema}
 */
export interface UsersDomainUsersByEmailSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  mfa_methods?: ('TOTP' | 'MAIL_2SV')[];
  mfa_required?: boolean;
  next_url?: string;
  objects?: UsersUserElastic[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `UserElastic`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserElastic}
 */
export interface UsersUserElastic {
  date_checklist_completed?: string | null;
  date_created?: string;
  date_first_uploaded?: string | null;
  date_modified?: string;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string;
  email?: string;
  email_marketing_consent?: boolean | null;
  external_id?: string;
  first_name?: string | null;
  groups?: string[];
  hide_email?: boolean;
  hide_phone?: boolean;
  id?: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  primary_group?: string;
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadata;
  system_name?: string;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UserSystemMetadata`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserSystemMetadata}
 */
export interface UsersUserSystemMetadata {
  saml_created?: boolean;
}
/**
 * Original schema `GroupBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupBaseSchema}
 */
export interface UsersGroupBaseSchema {
  alias?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id?: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  name: string;
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadata;
}
/**
 * Original schema `GroupSystemMetadata`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupSystemMetadata}
 */
export interface UsersGroupSystemMetadata {
  scim_config_id?: string;
  scim_created?: boolean;
}
/**
 * Original schema `GroupCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupCreateSchema}
 */
export interface UsersGroupCreateSchema {
  alias?: string;
  date_created?: string;
  date_modified?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id?: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  name: string;
  role_categories?: UsersRoleCategories | null;
  roles?: string[];
  saml_primary_group_priority?: number | null;
  system_domain_id: string;
  system_metadata?: UsersGroupSystemMetadata;
}
/**
 * Original schema `RoleCategories`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-RoleCategories}
 */
export interface UsersRoleCategories {
  assets_edit?: boolean;
  billing?: boolean;
  collaborate?: boolean;
  core?: boolean;
  download?: boolean;
  face_recognition?: boolean;
  integrations_admin?: boolean;
  metadata_admin?: boolean;
  organize?: boolean;
  others?: boolean;
  publish?: boolean;
  storage_admin?: boolean;
  upload?: boolean;
  users_groups_admin?: boolean;
}
/**
 * Original schema `GroupElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupElasticSchema}
 */
export interface UsersGroupElasticSchema {
  alias?: string;
  date_created?: string;
  date_modified?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id?: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  name: string;
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadata;
}
/**
 * Original schema `GroupMappingSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupMappingSchema}
 */
export interface UsersGroupMappingSchema {
  group_id: string;
  name: string;
}
/**
 * Original schema `GroupMappingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupMappingsSchema}
 */
export interface UsersGroupMappingsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: UsersGroupMappingSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `GroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupSchema}
 */
export interface UsersGroupSchema {
  alias?: string;
  date_created?: string;
  date_modified?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id?: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  logo?: string;
  name: string;
  role_categories?: UsersRoleCategories | null;
  roles?: string[];
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadata;
}
/**
 * Original schema `GroupSystemMetadataSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupSystemMetadataSchema}
 */
export interface UsersGroupSystemMetadataSchema {
  scim_config_id?: string;
  scim_created?: boolean;
}
/**
 * Original schema `GroupWithRolesBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupWithRolesBaseSchema}
 */
export interface UsersGroupWithRolesBaseSchema {
  alias?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id?: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  name: string;
  role_categories?: UsersRoleCategories | null;
  roles?: string[];
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadataSchema;
}
/**
 * Original schema `GroupWithRolesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupWithRolesElasticSchema}
 */
export interface UsersGroupWithRolesElasticSchema {
  alias?: string;
  date_created?: string;
  date_modified?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id?: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  name: string;
  role_categories?: UsersRoleCategories | null;
  roles?: string[];
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadataSchema;
}
/**
 * Original schema `GroupsQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupsQueryParamsSchema}
 */
export interface UsersGroupsQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `GroupsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupsSchema}
 */
export interface UsersGroupsSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: UsersGroupWithRolesElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `ListObjectsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-ListObjectsSchema}
 */
export interface UsersListObjectsSchema {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `MultiplatformUserPasswordEditSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-MultiplatformUserPasswordEditSchema}
 */
export interface UsersMultiplatformUserPasswordEditSchema {
  current_password?: string;
  email: string;
  ignore_current_password?: boolean | null;
  password: string;
}
/**
 * Original schema `MultiplatformUserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-MultiplatformUserSchema}
 */
export interface UsersMultiplatformUserSchema {
  email: string;
}
/**
 * Original schema `OtpEditInternalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-OtpEditInternalSchema}
 */
export interface UsersOtpEditInternalSchema {
  email: string;
  mfa_required?: boolean;
}
/**
 * Original schema `OtpEditSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-OtpEditSchema}
 */
export interface UsersOtpEditSchema {
  mfa_required?: boolean;
  otp: string;
  otp_type: 'TOTP' | 'MAIL_2SV';
}
/**
 * Original schema `OtpGenerateInternalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-OtpGenerateInternalSchema}
 */
export interface UsersOtpGenerateInternalSchema {
  email: string;
}
/**
 * Original schema `OtpInternalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-OtpInternalSchema}
 */
export interface UsersOtpInternalSchema {
  email: string;
  otp: string;
  otp_type: 'TOTP' | 'MAIL_2SV';
}
/**
 * Original schema `OtpSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-OtpSchema}
 */
export interface UsersOtpSchema {
  otp: string;
  otp_type: 'TOTP' | 'MAIL_2SV';
}
/**
 * Original schema `PartnerDomainAccessSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-PartnerDomainAccessSchema}
 */
export interface UsersPartnerDomainAccessSchema {
  customer_domain_id: string;
  partner_domain_id: string;
}
/**
 * Original schema `ReindexGroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-ReindexGroupSchema}
 */
export interface UsersReindexGroupSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `ReindexUserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-ReindexUserSchema}
 */
export interface UsersReindexUserSchema {
  sync_to_another_dc?: boolean;
}
/**
 * Original schema `RoleCategoriesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-RoleCategoriesSchema}
 */
export interface UsersRoleCategoriesSchema {
  assets_edit?: boolean;
  billing?: boolean;
  collaborate?: boolean;
  core?: boolean;
  download?: boolean;
  face_recognition?: boolean;
  integrations_admin?: boolean;
  metadata_admin?: boolean;
  organize?: boolean;
  others?: boolean;
  publish?: boolean;
  storage_admin?: boolean;
  upload?: boolean;
  users_groups_admin?: boolean;
}
/**
 * Original schema `RoleGroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-RoleGroupSchema}
 */
export interface UsersRoleGroupSchema {
  alias?: string;
  date_created?: string;
  date_modified?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id?: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  name: string;
  role_categories?: UsersRoleCategoriesSchema | null;
  roles?: string[];
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadataSchema;
}
/**
 * Original schema `RoleGroupsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-RoleGroupsSchema}
 */
export interface UsersRoleGroupsSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: UsersGroupWithRolesElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `TeamSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-TeamSchema}
 */
export interface UsersTeamSchema {
  alias?: string;
  date_created?: string;
  date_modified?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id?: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  logo?: string;
  name: string;
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadataSchema;
}
/**
 * Original schema `TeamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-TeamsSchema}
 */
export interface UsersTeamsSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: UsersGroupElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `UserBaseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserBaseSchema}
 */
export interface UsersUserBaseSchema {
  date_checklist_completed?: string | null;
  date_first_uploaded?: string | null;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  email?: string;
  email_marketing_consent?: boolean | null;
  external_id?: string;
  first_name?: string | null;
  groups?: string[];
  hide_email?: boolean;
  hide_phone?: boolean;
  id?: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  primary_group?: string;
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadata;
  system_name?: string;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UserBasicElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserBasicElasticSchema}
 */
export interface UsersUserBasicElasticSchema {
  email?: string;
  first_name?: string | null;
  id?: string;
  last_name?: string | null;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  photo_storage_id?: string;
}
/**
 * Original schema `UserByEmailAndLoginTypeSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserByEmailAndLoginTypeSchema}
 */
export interface UsersUserByEmailAndLoginTypeSchema {
  email: string;
  login_type?: 'SSO' | 'PASSWORD';
}
/**
 * Original schema `UserByEmailSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserByEmailSchema}
 */
export interface UsersUserByEmailSchema {
  email: string;
}
/**
 * Original schema `UserByExternalIdSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserByExternalIdSchema}
 */
export interface UsersUserByExternalIdSchema {
  external_id: string;
}
/**
 * Original schema `UserCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserCreateSchema}
 */
export interface UsersUserCreateSchema {
  date_checklist_completed?: string | null;
  date_created?: string;
  date_first_uploaded?: string | null;
  date_modified?: string;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string;
  email: string;
  email_marketing_consent?: boolean | null;
  external_id?: string;
  first_name?: string | null;
  groups?: string[];
  hide_email?: boolean;
  hide_phone?: boolean;
  id?: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  primary_group?: string;
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadata;
  system_name?: string;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UserEditInternalSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserEditInternalSchema}
 */
export interface UsersUserEditInternalSchema {
  current_password?: string;
  date_checklist_completed?: string | null;
  date_first_uploaded?: string | null;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string;
  email?: string;
  email_marketing_consent?: boolean | null;
  external_id?: string;
  first_name?: string | null;
  groups?: string[];
  hide_email?: boolean;
  hide_phone?: boolean;
  id?: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  primary_group?: string;
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadata;
  system_name?: string;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UserEditSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserEditSchema}
 */
export interface UsersUserEditSchema {
  current_password?: string;
  date_checklist_completed?: string | null;
  date_first_uploaded?: string | null;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string;
  email?: string;
  email_marketing_consent?: boolean | null;
  external_id?: string;
  first_name?: string | null;
  groups?: string[];
  hide_email?: boolean;
  hide_phone?: boolean;
  id?: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  primary_group?: string;
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadata;
  system_name?: string;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UserElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserElasticSchema}
 */
export interface UsersUserElasticSchema {
  date_checklist_completed?: string | null;
  date_created?: string;
  date_first_uploaded?: string | null;
  date_modified?: string;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string;
  email?: string;
  email_marketing_consent?: boolean | null;
  external_id?: string;
  first_name?: string | null;
  groups?: string[];
  hide_email?: boolean;
  hide_phone?: boolean;
  id?: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  primary_group?: string;
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadata;
  system_name?: string;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UserInviteRegisterRequestSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserInviteRegisterRequestSchema}
 */
export interface UsersUserInviteRegisterRequestSchema {
  email: string;
  first_name: string;
  last_name?: string;
  token: string;
}
/**
 * Original schema `UserInviteRegisterResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserInviteRegisterResponseSchema}
 */
export interface UsersUserInviteRegisterResponseSchema {
  id?: string;
  is_existing_user?: boolean;
}
/**
 * Original schema `UserInviteRequestLinkSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserInviteRequestLinkSchema}
 */
export interface UsersUserInviteRequestLinkSchema {
  groups?: string[];
  is_admin?: boolean;
  primary_group: string;
  type?: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UserLoginSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserLoginSchema}
 */
export interface UsersUserLoginSchema {
  email: string;
  password: string;
}
/**
 * Original schema `UserOTPEditMultiPlatformSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserOTPEditMultiPlatformSchema}
 */
export interface UsersUserOTPEditMultiPlatformSchema {
  email: string;
  mfa_required?: boolean | null;
  otp_secret?: string | null;
  totp_last_counter?: number | null;
  totp_verified?: boolean | null;
}
/**
 * Original schema `UserRolesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserRolesSchema}
 */
export interface UsersUserRolesSchema {
  objects?: string[];
}
/**
 * Original schema `UserSamlCreateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserSamlCreateSchema}
 */
export interface UsersUserSamlCreateSchema {
  date_checklist_completed?: string | null;
  date_created?: string;
  date_first_uploaded?: string | null;
  date_modified?: string;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  email: string;
  email_marketing_consent?: boolean | null;
  external_id?: string | null;
  first_name?: string | null;
  group_names?: string[];
  groups?: string[];
  hide_email?: boolean;
  hide_phone?: boolean;
  id?: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  primary_group?: string;
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadata;
  system_name?: string;
  type?: ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY') | null;
}
/**
 * Original schema `UserSamlIdpUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserSamlIdpUpdateSchema}
 */
export interface UsersUserSamlIdpUpdateSchema {
  email: string;
  identity_provider_id: string;
}
/**
 * Original schema `UserSamlUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserSamlUpdateSchema}
 */
export interface UsersUserSamlUpdateSchema {
  email: string;
  external_id?: string | null;
  first_name?: string;
  group_names?: string[];
  identity_provider_id?: string;
  last_name?: string;
}
/**
 * Original schema `UserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserSchema}
 */
export interface UsersUserSchema {
  app_id?: string;
  date_checklist_completed?: string | null;
  date_created?: string;
  date_first_uploaded?: string | null;
  date_modified?: string;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string;
  disable_mixpanel?: boolean;
  email?: string;
  email_marketing_consent?: boolean | null;
  external_id?: string;
  first_name?: string | null;
  groups?: string[];
  has_domain_been_migrated_to_simplified_acls?: boolean;
  hide_email?: boolean;
  hide_phone?: boolean;
  id?: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  photo_storage_id?: string;
  primary_group?: string;
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadata;
  system_name?: string;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UserScimUpdateSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserScimUpdateSchema}
 */
export interface UsersUserScimUpdateSchema {
  email?: string;
  external_id?: string | null;
  first_name?: string | null;
  last_name?: string | null;
}
/**
 * Original schema `UserSystemMetadataSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserSystemMetadataSchema}
 */
export interface UsersUserSystemMetadataSchema {
  saml_created?: boolean;
}
/**
 * Original schema `UserTypeCountsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserTypeCountsSchema}
 */
export interface UsersUserTypeCountsSchema {
  BROWSE_API_ONLY?: number;
  BROWSE_ONLY?: number;
  POWER?: number;
  STANDARD?: number;
}
/**
 * Original schema `UserWithSeparatedGroupsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserWithSeparatedGroupsSchema}
 */
export interface UsersUserWithSeparatedGroupsSchema {
  app_id?: string;
  date_checklist_completed?: string | null;
  date_created?: string;
  date_first_uploaded?: string | null;
  date_modified?: string;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string;
  disable_mixpanel?: boolean;
  email?: string;
  email_marketing_consent?: boolean | null;
  external_id?: string;
  first_name?: string | null;
  groups?: string[];
  has_domain_been_migrated_to_simplified_acls?: boolean;
  hide_email?: boolean;
  hide_phone?: boolean;
  id?: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  photo_storage_id?: string;
  primary_group?: string;
  role_groups?: string[];
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadataSchema;
  system_name?: string;
  teams?: string[];
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UsersBasicSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UsersBasicSchema}
 */
export interface UsersUsersBasicSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: UsersUserBasicElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `UsersByEmailsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UsersByEmailsSchema}
 */
export interface UsersUsersByEmailsSchema {
  emails: string[];
}
/**
 * Original schema `UsersQueryParamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UsersQueryParamsSchema}
 */
export interface UsersUsersQueryParamsSchema {
  /**
   * Which page number to fetch
   */
  page?: number | null;
  /**
   * The number of items for each page
   */
  per_page?: number | null;
  /**
   * A comma separated list of fieldnames with order (asc/desc)
   */
  sort?: string;
}
/**
 * Original schema `UsersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UsersSchema}
 */
export interface UsersUsersSchema {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects?: UsersUserElasticSchema[];
  page?: number;
  pages?: number;
  per_page?: number;
  prev_url?: string;
  total?: number;
}
/**
 * Original schema `GroupsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupsSchema}
 */
export interface UsersGroupsSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: UsersGroupWithRolesElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `GroupWithRolesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupWithRolesElasticSchema}
 */
export interface UsersGroupWithRolesElasticSchemaWithIdNullable {
  alias?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string | null;
  external_id?: string | null;
  group_type?: ('TEAM' | 'ROLE_GROUP') | null;
  id: string;
  is_legacy_everyone?: boolean | null;
  is_saml_group?: boolean | null;
  name: string;
  role_categories?: UsersRoleCategories | null;
  roles?: string[] | null;
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadataSchema | null;
}
/**
 * Original schema `GroupWithRolesElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupWithRolesElasticSchema}
 */
export interface UsersGroupWithRolesElasticSchemaWithId {
  alias?: string;
  date_created?: string;
  date_modified?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  name: string;
  role_categories?: UsersRoleCategories | null;
  roles?: string[];
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadataSchema;
}
/**
 * Original schema `GroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupSchema}
 */
export interface UsersGroupSchemaWithId {
  alias?: string;
  date_created?: string;
  date_modified?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  logo?: string;
  name: string;
  role_categories?: UsersRoleCategories | null;
  roles?: string[];
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadata;
}
/**
 * Original schema `GroupMappingsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupMappingsSchema}
 */
export interface UsersGroupMappingsSchemaWithId {
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: UsersGroupMappingSchema[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `GroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupSchema}
 */
export interface UsersGroupSchemaWithIdNullable {
  alias?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string | null;
  external_id?: string | null;
  group_type?: ('TEAM' | 'ROLE_GROUP') | null;
  id: string;
  is_legacy_everyone?: boolean | null;
  is_saml_group?: boolean | null;
  logo?: string | null;
  name: string;
  role_categories?: UsersRoleCategories | null;
  roles?: string[] | null;
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadata | null;
}
/**
 * Original schema `UserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserSchema}
 */
export interface UsersUserSchemaWithId {
  app_id?: string;
  date_checklist_completed?: string | null;
  date_created?: string;
  date_first_uploaded?: string | null;
  date_modified?: string;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string;
  disable_mixpanel?: boolean;
  email?: string;
  email_marketing_consent?: boolean | null;
  external_id?: string;
  first_name?: string | null;
  groups?: string[];
  has_domain_been_migrated_to_simplified_acls?: boolean;
  hide_email?: boolean;
  hide_phone?: boolean;
  id: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  photo_storage_id?: string;
  primary_group?: string;
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadata;
  system_name?: string;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `RoleGroupsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-RoleGroupsSchema}
 */
export interface UsersRoleGroupsSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: UsersGroupWithRolesElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `RoleGroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-RoleGroupSchema}
 */
export interface UsersRoleGroupSchemaWithId {
  alias?: string;
  date_created?: string;
  date_modified?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  name: string;
  role_categories?: UsersRoleCategoriesSchema | null;
  roles?: string[];
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadataSchema;
}
/**
 * Original schema `RoleGroupSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-RoleGroupSchema}
 */
export interface UsersRoleGroupSchemaWithIdNullable {
  alias?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string | null;
  external_id?: string | null;
  group_type?: ('TEAM' | 'ROLE_GROUP') | null;
  id: string;
  is_legacy_everyone?: boolean | null;
  is_saml_group?: boolean | null;
  name: string;
  role_categories?: UsersRoleCategoriesSchema | null;
  roles?: string[] | null;
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadataSchema | null;
}
/**
 * Original schema `UserWithSeparatedGroupsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserWithSeparatedGroupsSchema}
 */
export interface UsersUserWithSeparatedGroupsSchemaWithId {
  app_id?: string;
  date_checklist_completed?: string | null;
  date_created?: string;
  date_first_uploaded?: string | null;
  date_modified?: string;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string;
  disable_mixpanel?: boolean;
  email?: string;
  email_marketing_consent?: boolean | null;
  external_id?: string;
  first_name?: string | null;
  groups?: string[];
  has_domain_been_migrated_to_simplified_acls?: boolean;
  hide_email?: boolean;
  hide_phone?: boolean;
  id: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  photo_storage_id?: string;
  primary_group?: string;
  role_groups?: string[];
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadataSchema;
  system_name?: string;
  teams?: string[];
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `TeamsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-TeamsSchema}
 */
export interface UsersTeamsSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: UsersGroupElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `GroupElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupElasticSchema}
 */
export interface UsersGroupElasticSchemaWithIdNullable {
  alias?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string | null;
  external_id?: string | null;
  group_type?: ('TEAM' | 'ROLE_GROUP') | null;
  id: string;
  is_legacy_everyone?: boolean | null;
  is_saml_group?: boolean | null;
  name: string;
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadata | null;
}
/**
 * Original schema `GroupElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-GroupElasticSchema}
 */
export interface UsersGroupElasticSchemaWithId {
  alias?: string;
  date_created?: string;
  date_modified?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  name: string;
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadata;
}
/**
 * Original schema `TeamSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-TeamSchema}
 */
export interface UsersTeamSchemaWithId {
  alias?: string;
  date_created?: string;
  date_modified?: string;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string;
  external_id?: string | null;
  group_type?: 'TEAM' | 'ROLE_GROUP';
  id: string;
  is_legacy_everyone?: boolean;
  is_saml_group?: boolean;
  logo?: string;
  name: string;
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadataSchema;
}
/**
 * Original schema `TeamSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-TeamSchema}
 */
export interface UsersTeamSchemaWithIdNullable {
  alias?: string | null;
  date_created?: string | null;
  date_modified?: string | null;
  default_user_type?:
    | ('POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY')
    | null;
  description?: string | null;
  external_id?: string | null;
  group_type?: ('TEAM' | 'ROLE_GROUP') | null;
  id: string;
  is_legacy_everyone?: boolean | null;
  is_saml_group?: boolean | null;
  logo?: string | null;
  name: string;
  saml_primary_group_priority?: number | null;
  system_metadata?: UsersGroupSystemMetadataSchema | null;
}
/**
 * Original schema `UsersSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UsersSchema}
 */
export interface UsersUsersSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: UsersUserElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `UserElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserElasticSchema}
 */
export interface UsersUserElasticSchemaWithIdNullable {
  date_checklist_completed?: string | null;
  date_created?: string | null;
  date_first_uploaded?: string | null;
  date_modified?: string | null;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string | null;
  email?: string | null;
  email_marketing_consent?: boolean | null;
  external_id?: string | null;
  first_name?: string | null;
  groups?: string[] | null;
  hide_email?: boolean | null;
  hide_phone?: boolean | null;
  id: string;
  identity_provider_id?: string | null;
  is_admin?: boolean | null;
  is_super_admin?: boolean | null;
  is_super_admin_light?: boolean | null;
  last_name?: string | null;
  last_successful_auth?: string | null;
  last_unsuccessful_auth?: string | null;
  last_web_login?: string | null;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string | null;
  password_changed?: string | null;
  phone?: string | null;
  photo?: string | null;
  photo_big?: string | null;
  photo_small?: string | null;
  primary_group?: string | null;
  status?: ('INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED') | null;
  system_domain_id?: string | null;
  system_domains?: string[] | null;
  system_metadata?: UsersUserSystemMetadata | null;
  system_name?: string | null;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UserElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserElasticSchema}
 */
export interface UsersUserElasticSchemaWithId {
  date_checklist_completed?: string | null;
  date_created?: string;
  date_first_uploaded?: string | null;
  date_modified?: string;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string;
  email?: string;
  email_marketing_consent?: boolean | null;
  external_id?: string;
  first_name?: string | null;
  groups?: string[];
  hide_email?: boolean;
  hide_phone?: boolean;
  id: string;
  identity_provider_id?: string;
  is_admin?: boolean;
  is_super_admin?: boolean;
  is_super_admin_light?: boolean;
  last_name?: string | null;
  last_successful_auth?: string;
  last_unsuccessful_auth?: string;
  last_web_login?: string;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string;
  password_changed?: string;
  phone?: string;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  primary_group?: string;
  status?: 'INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED';
  system_domain_id?: string;
  system_domains?: string[];
  system_metadata?: UsersUserSystemMetadata;
  system_name?: string;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UsersBasicSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UsersBasicSchema}
 */
export interface UsersUsersBasicSchemaWithId {
  facets?: {
    [k: string]: unknown;
  };
  first_url?: string;
  last_url?: string;
  next_url?: string;
  objects: UsersUserBasicElasticSchemaWithIdNullable[];
  page: number;
  pages: number;
  per_page: number;
  prev_url?: string;
  total: number;
}
/**
 * Original schema `UserBasicElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserBasicElasticSchema}
 */
export interface UsersUserBasicElasticSchemaWithIdNullable {
  email?: string | null;
  first_name?: string | null;
  id: string;
  last_name?: string | null;
  photo?: string | null;
  photo_big?: string | null;
  photo_small?: string | null;
  photo_storage_id?: string | null;
}
/**
 * Original schema `UserBasicElasticSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserBasicElasticSchema}
 */
export interface UsersUserBasicElasticSchemaWithId {
  email?: string;
  first_name?: string | null;
  id: string;
  last_name?: string | null;
  photo?: string;
  photo_big?: string;
  photo_small?: string;
  photo_storage_id?: string;
}
/**
 * Original schema `UserSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserSchema}
 */
export interface UsersUserSchemaWithIdNullable {
  app_id?: string | null;
  date_checklist_completed?: string | null;
  date_created?: string | null;
  date_first_uploaded?: string | null;
  date_modified?: string | null;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string | null;
  disable_mixpanel?: boolean | null;
  email?: string | null;
  email_marketing_consent?: boolean | null;
  external_id?: string | null;
  first_name?: string | null;
  groups?: string[] | null;
  has_domain_been_migrated_to_simplified_acls?: boolean | null;
  hide_email?: boolean | null;
  hide_phone?: boolean | null;
  id: string;
  identity_provider_id?: string | null;
  is_admin?: boolean | null;
  is_super_admin?: boolean | null;
  is_super_admin_light?: boolean | null;
  last_name?: string | null;
  last_successful_auth?: string | null;
  last_unsuccessful_auth?: string | null;
  last_web_login?: string | null;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string | null;
  password_changed?: string | null;
  phone?: string | null;
  photo?: string | null;
  photo_big?: string | null;
  photo_small?: string | null;
  photo_storage_id?: string | null;
  primary_group?: string | null;
  status?: ('INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED') | null;
  system_domain_id?: string | null;
  system_domains?: string[] | null;
  system_metadata?: UsersUserSystemMetadata | null;
  system_name?: string | null;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
/**
 * Original schema `UserRolesSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserRolesSchema}
 */
export interface UsersUserRolesSchemaWithId {
  objects: string[];
}
/**
 * Original schema `UserInviteRegisterResponseSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserInviteRegisterResponseSchema}
 */
export interface UsersUserInviteRegisterResponseSchemaWithId {
  id: string;
  is_existing_user?: boolean;
}
/**
 * Original schema `UserWithSeparatedGroupsSchema`
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#model-UserWithSeparatedGroupsSchema}
 */
export interface UsersUserWithSeparatedGroupsSchemaWithIdNullable {
  app_id?: string | null;
  date_checklist_completed?: string | null;
  date_created?: string | null;
  date_first_uploaded?: string | null;
  date_modified?: string | null;
  date_returned?: string | null;
  date_terms_accepted?: string | null;
  date_visited_dashboard?: string | null;
  date_welcomed?: string | null;
  /**
   * Available only for admin users
   */
  description?: string | null;
  disable_mixpanel?: boolean | null;
  email?: string | null;
  email_marketing_consent?: boolean | null;
  external_id?: string | null;
  first_name?: string | null;
  groups?: string[] | null;
  has_domain_been_migrated_to_simplified_acls?: boolean | null;
  hide_email?: boolean | null;
  hide_phone?: boolean | null;
  id: string;
  identity_provider_id?: string | null;
  is_admin?: boolean | null;
  is_super_admin?: boolean | null;
  is_super_admin_light?: boolean | null;
  last_name?: string | null;
  last_successful_auth?: string | null;
  last_unsuccessful_auth?: string | null;
  last_web_login?: string | null;
  metadata?: unknown;
  onboarding_goal?: ('CENTRALIZE' | 'COLLABORATE' | 'REVISIT') | null;
  password?: string | null;
  password_changed?: string | null;
  phone?: string | null;
  photo?: string | null;
  photo_big?: string | null;
  photo_small?: string | null;
  photo_storage_id?: string | null;
  primary_group?: string | null;
  role_groups?: string[] | null;
  status?: ('INACTIVE' | 'ACTIVE' | 'BLOCKED' | 'DELETED') | null;
  system_domain_id?: string | null;
  system_domains?: string[] | null;
  system_metadata?: UsersUserSystemMetadataSchema | null;
  system_name?: string | null;
  teams?: string[] | null;
  type: 'POWER' | 'STANDARD' | 'BROWSE_ONLY' | 'BROWSE_API_ONLY';
}
export interface UsersAllRolesSchema {
  objects: string[];
  standard: string[];
  browse_only: string[];
  browse_api_only: string[];
}

export interface UsersHttpGetGroupsQuery {
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc If omitted, results default to sorting by date_created,desc.
   */
  sort?: string;
  /**
   * Filter by alias
   */
  alias?: string;
  /**
   * Filter by descripton
   */
  description?: string;
  /**
   * Filter by name
   */
  name?: string;
  /**
   * Filter by roles
   */
  roles?: string;
  /**
   * Filter by date_created
   */
  date_created?: string;
  /**
   * Filter by date_modified
   */
  date_modified?: string;
  /**
   * Filter by any of field with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
}

/**
 * `GET /v1/groups/`
 *
 * List groups with details
 *
 *
 * Responses
 * - 200 - Returns a list of groups
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link UsersGroupsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_groups_}
 */
export const httpGetGroups = (
  query?: UsersHttpGetGroupsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetGroups,
  method: httpMethod.get,
  url: '/API/users/v1/groups/',

  query,
  headers,
});

/**
 * `POST /v1/groups/`
 *
 * Create a new group
 *
 * Required roles:
 *  - can_write_groups
 *
 * Responses
 * - 201 - Returns a created group
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link UsersGroupSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_groups_}
 */
export const httpPostGroups = (
  body: UsersGroupSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostGroups,
  method: httpMethod.post,
  url: '/API/users/v1/groups/',

  body,
  headers,
});

export interface UsersHttpGetGroupsAllBasicQuery {
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - name,asc;date_created,desc If omitted, results default to sorting by date_created,desc.
   */
  sort?: string;
  /**
   * Filter by any of first_name, last_name and email with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
}

/**
 * `GET /v1/groups/all/basic/`
 *
 * List all groups without details
 *
 *
 * Responses
 * - 200 - Returns a list of groups
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link UsersGroupsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_groups_all_basic_}
 */
export const httpGetGroupsAllBasic = (
  query?: UsersHttpGetGroupsAllBasicQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetGroupsAllBasic,
  method: httpMethod.get,
  url: '/API/users/v1/groups/all/basic/',

  query,
  headers,
});

export interface UsersHttpGetGroupsBasicQuery {
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc If omitted, results default to sorting by date_created,desc.
   */
  sort?: string;
  /**
   * Filter by alias
   */
  alias?: string;
  /**
   * Filter by descripton
   */
  description?: string;
  /**
   * Filter by name
   */
  name?: string;
  /**
   * Filter by roles
   */
  roles?: string;
  /**
   * Filter by date_created
   */
  date_created?: string;
  /**
   * Filter by date_modified
   */
  date_modified?: string;
  /**
   * Filter by any of first_name, last_name and email with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
}

/**
 * `GET /v1/groups/basic/`
 *
 * List untyped groups without details
 *
 *
 * Responses
 * - 200 - Returns a list of groups
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link UsersGroupsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_groups_basic_}
 */
export const httpGetGroupsBasic = (
  query?: UsersHttpGetGroupsBasicQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetGroupsBasic,
  method: httpMethod.get,
  url: '/API/users/v1/groups/basic/',

  query,
  headers,
});

export interface UsersHttpGetGroupsMappingsQuery {
  /**
   * The number of items for each page
   */
  per_page?: number;
  last_id?: string;
}

/**
 * `GET /v1/groups/mappings/`
 *
 * Get all group mappings
 *
 * Required roles:
 *  - can_read_group_mappings
 *
 * Responses
 * - 200 - Returns a list of group mappings
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link UsersGroupMappingsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_groups_mappings_}
 */
export const httpGetGroupsMappings = (
  query?: UsersHttpGetGroupsMappingsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetGroupsMappings,
  method: httpMethod.get,
  url: '/API/users/v1/groups/mappings/',

  query,
  headers,
});

/**
 * `POST /v1/groups/mappings/`
 *
 * Create a new group mapping
 *
 * Required roles:
 *  - can_write_group_mappings
 *
 * Responses
 * - 201 - Returns a created group mapping
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 409 - Group mapping already exists
 *
 * Response {@link UsersGroupMappingSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_groups_mappings_}
 */
export const httpPostGroupsMappings = (
  body: UsersGroupMappingSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostGroupsMappings,
  method: httpMethod.post,
  url: '/API/users/v1/groups/mappings/',

  body,
  headers,
});

/**
 * `DELETE /v1/groups/mappings/{name}/`
 *
 * Delete group mapping by name
 *
 * Required roles:
 *  - can_delete_group_mappings
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Group mapping does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_groups_mappings__name__}
 */
export const httpDeleteGroupsMappingsByName = (
  name: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteGroupsMappingsByName,
  method: httpMethod.delete,
  url: `/API/users/v1/groups/mappings/${encodeURIComponent(name)}/`,
  params: { name },
  headers,
});

/**
 * `GET /v1/groups/mappings/{name}/`
 *
 * Get a group mapping
 *
 * Required roles:
 *  - can_read_group_mappings
 *
 * Responses
 * - 200 - Returns a group mapping
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link UsersGroupMappingSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_groups_mappings__name__}
 */
export const httpGetGroupsMappingsByName = (
  name: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetGroupsMappingsByName,
  method: httpMethod.get,
  url: `/API/users/v1/groups/mappings/${encodeURIComponent(name)}/`,
  params: { name },
  headers,
});

/**
 * `DELETE /v1/groups/{group_id}/`
 *
 * Delete a particular group by id
 *
 * Required roles:
 *  - can_delete_groups
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Group does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_groups__group_id__}
 */
export const httpDeleteGroupsByGroupId = (
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteGroupsByGroupId,
  method: httpMethod.delete,
  url: `/API/users/v1/groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  headers,
});

/**
 * `GET /v1/groups/{group_id}/`
 *
 * Returns a particular group by id
 *
 * Required roles:
 *  - can_read_groups
 *
 * Responses
 * - 200 - Returns a group
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Group does not exist
 *
 * Response {@link UsersGroupSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_groups__group_id__}
 */
export const httpGetGroupsByGroupId = (
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetGroupsByGroupId,
  method: httpMethod.get,
  url: `/API/users/v1/groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  headers,
});

export type UsersGroupSchemaPartial = Partial<UsersGroupSchema>;

/**
 * `PATCH /v1/groups/{group_id}/`
 *
 * Update group
 *
 * Required roles:
 *  - can_write_groups
 *
 * Responses
 * - 200 - Returns an updated group
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Group does not exist
 *
 * Response {@link UsersGroupSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/patch_v1_groups__group_id__}
 */
export const httpPatchGroupsByGroupId = (
  groupId: string,
  body: UsersGroupSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPatchGroupsByGroupId,
  method: httpMethod.patch,
  url: `/API/users/v1/groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  body,
  headers,
});

/**
 * `PUT /v1/groups/{group_id}/`
 *
 * Update group
 *
 * Required roles:
 *  - can_write_groups
 *
 * Responses
 * - 200 - Returns an updated group
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Group does not exist
 *
 * Response {@link UsersGroupSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/put_v1_groups__group_id__}
 */
export const httpPutGroupsByGroupId = (
  groupId: string,
  body: UsersGroupSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPutGroupsByGroupId,
  method: httpMethod.put,
  url: `/API/users/v1/groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  body,
  headers,
});

/**
 * `DELETE /v1/groups/{group_id}/logo/`
 *
 * Delete group logo image
 *
 * Required roles:
 *  - can_write_groups
 *
 * Responses
 * - 204 - No body
 * - 400 - Bad request
 * - 404 - Group does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_groups__group_id__logo_}
 */
export const httpDeleteGroupsByGroupIdLogo = (
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteGroupsByGroupIdLogo,
  method: httpMethod.delete,
  url: `/API/users/v1/groups/${encodeURIComponent(groupId)}/logo/`,
  params: { groupId },
  headers,
});

/**
 * Returns url for group logo
 */
export interface UsersHttpPostGroupsByGroupIdLogoResponse {
  /**
   * Url for the group logo
   */
  logo?: string;
}

/**
 * `POST /v1/groups/{group_id}/logo/`
 *
 * Upload group logo image
 *
 * Required roles:
 *  - can_write_groups
 *
 * Responses
 * - 200 - Returns url for group logo
 * - 400 - Bad request
 * - 404 - Group does not exist
 *
 * Response {@link UsersHttpPostGroupsByGroupIdLogoResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_groups__group_id__logo_}
 */
export const httpPostGroupsByGroupIdLogo = (
  groupId: string,
  formData: FormData,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostGroupsByGroupIdLogo,
  method: httpMethod.post,
  url: `/API/users/v1/groups/${encodeURIComponent(groupId)}/logo/`,
  params: { groupId },
  body: formData,
  headers,
});

/**
 * `POST /v1/groups/{group_id}/reindex/`
 *
 * Reindex a particular group by id
 *
 * Required roles:
 *  - can_reindex_groups
 *
 * Responses
 * - 200 - Returns a job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Group does not exist
 *
 * Response {@link UsersUserSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_groups__group_id__reindex_}
 */
export const httpPostGroupsByGroupIdReindex = (
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostGroupsByGroupIdReindex,
  method: httpMethod.post,
  url: `/API/users/v1/groups/${encodeURIComponent(groupId)}/reindex/`,
  params: { groupId },
  headers,
});

/**
 * `DELETE /v1/groups/{group_id}/users/{user_id}/`
 *
 * Delete a user from group
 *
 * Required roles:
 *  - can_delete_groups
 *
 * Responses
 * - 200 - Returns a user
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User or Group does not exist
 *
 * Response {@link UsersUserSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_groups__group_id__users__user_id__}
 */
export const httpDeleteGroupsByGroupIdUsersByUserId = (
  groupId: string,
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteGroupsByGroupIdUsersByUserId,
  method: httpMethod.delete,
  url: `/API/users/v1/groups/${encodeURIComponent(groupId)}/users/${encodeURIComponent(userId)}/`,
  params: { groupId, userId },
  headers,
});

export interface UsersHttpPostGroupsByGroupIdUsersByUserIdQuery {
  index_immediately?: string;
}

/**
 * `POST /v1/groups/{group_id}/users/{user_id}/`
 *
 * Add user into a group
 *
 * Required roles:
 *  - can_write_groups
 *
 * Responses
 * - 201 - Returns a user
 * - 401 - Token is invalid
 * - 404 - User or Group does not exist
 *
 * Response {@link UsersUserSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_groups__group_id__users__user_id__}
 */
export const httpPostGroupsByGroupIdUsersByUserId = (
  groupId: string,
  userId: string,
  query?: UsersHttpPostGroupsByGroupIdUsersByUserIdQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostGroupsByGroupIdUsersByUserId,
  method: httpMethod.post,
  url: `/API/users/v1/groups/${encodeURIComponent(groupId)}/users/${encodeURIComponent(userId)}/`,
  params: { groupId, userId },
  query,
  headers,
});

export interface UsersHttpGetRoleGroupsQuery {
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc If omitted, results default to sorting by date_created,desc.
   */
  sort?: string;
  /**
   * Filter by alias
   */
  alias?: string;
  /**
   * Filter by descripton
   */
  description?: string;
  /**
   * Filter by name
   */
  name?: string;
  /**
   * Filter by roles
   */
  roles?: string;
  /**
   * Filter by date_created
   */
  date_created?: string;
  /**
   * Filter by date_modified
   */
  date_modified?: string;
  /**
   * Filter by any of field with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
}

/**
 * `GET /v1/role_groups/`
 *
 * List role groups with details
 *
 * Required roles:
 *  - can_read_role_groups
 *
 * Responses
 * - 200 - Returns a list of role groups
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link UsersRoleGroupsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_role_groups_}
 */
export const httpGetRoleGroups = (
  query?: UsersHttpGetRoleGroupsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetRoleGroups,
  method: httpMethod.get,
  url: '/API/users/v1/role_groups/',

  query,
  headers,
});

/**
 * `POST /v1/role_groups/`
 *
 * Create a new role group
 *
 * Required roles:
 *  - can_write_role_groups
 *
 * Responses
 * - 201 - Returns a created role group
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link UsersRoleGroupSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_role_groups_}
 */
export const httpPostRoleGroups = (
  body: UsersRoleGroupSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostRoleGroups,
  method: httpMethod.post,
  url: '/API/users/v1/role_groups/',

  body,
  headers,
});

export interface UsersHttpGetRoleGroupsBasicQuery {
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc If omitted, results default to sorting by date_created,desc.
   */
  sort?: string;
  /**
   * Filter by alias
   */
  alias?: string;
  /**
   * Filter by descripton
   */
  description?: string;
  /**
   * Filter by name
   */
  name?: string;
  /**
   * Filter by roles
   */
  roles?: string;
  /**
   * Filter by date_created
   */
  date_created?: string;
  /**
   * Filter by date_modified
   */
  date_modified?: string;
  /**
   * Filter by any of first_name, last_name and email with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
}

/**
 * `GET /v1/role_groups/basic/`
 *
 * List role groups without details
 *
 *
 * Responses
 * - 200 - Returns a list of role groups
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link UsersGroupsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_role_groups_basic_}
 */
export const httpGetRoleGroupsBasic = (
  query?: UsersHttpGetRoleGroupsBasicQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetRoleGroupsBasic,
  method: httpMethod.get,
  url: '/API/users/v1/role_groups/basic/',

  query,
  headers,
});

/**
 * `DELETE /v1/role_groups/{group_id}/`
 *
 * Delete a particular role group by id
 *
 * Required roles:
 *  - can_delete_role_groups
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Role Group does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_role_groups__group_id__}
 */
export const httpDeleteRoleGroupsByGroupId = (
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteRoleGroupsByGroupId,
  method: httpMethod.delete,
  url: `/API/users/v1/role_groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  headers,
});

/**
 * `GET /v1/role_groups/{group_id}/`
 *
 * Returns a particular role group by id
 *
 * Required roles:
 *  - can_read_role_groups
 *
 * Responses
 * - 200 - Returns a role group
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Role Group does not exist
 *
 * Response {@link UsersRoleGroupSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_role_groups__group_id__}
 */
export const httpGetRoleGroupsByGroupId = (
  groupId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetRoleGroupsByGroupId,
  method: httpMethod.get,
  url: `/API/users/v1/role_groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  headers,
});

export type UsersRoleGroupSchemaPartial = Partial<UsersRoleGroupSchema>;

/**
 * `PATCH /v1/role_groups/{group_id}/`
 *
 * Update role group
 *
 * Required roles:
 *  - can_write_role_groups
 *
 * Responses
 * - 200 - Returns an updated role group
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Role Group does not exist
 *
 * Response {@link UsersRoleGroupSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/patch_v1_role_groups__group_id__}
 */
export const httpPatchRoleGroupsByGroupId = (
  groupId: string,
  body: UsersRoleGroupSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPatchRoleGroupsByGroupId,
  method: httpMethod.patch,
  url: `/API/users/v1/role_groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  body,
  headers,
});

/**
 * `PUT /v1/role_groups/{group_id}/`
 *
 * Update role group
 *
 * Required roles:
 *  - can_write_role_groups
 *
 * Responses
 * - 200 - Returns an updated role group
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Role Group does not exist
 *
 * Response {@link UsersRoleGroupSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/put_v1_role_groups__group_id__}
 */
export const httpPutRoleGroupsByGroupId = (
  groupId: string,
  body: UsersRoleGroupSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPutRoleGroupsByGroupId,
  method: httpMethod.put,
  url: `/API/users/v1/role_groups/${encodeURIComponent(groupId)}/`,
  params: { groupId },
  body,
  headers,
});

/**
 * `DELETE /v1/role_groups/{group_id}/users/{user_id}/`
 *
 * Delete a user from role group
 *
 * Required roles:
 *  - can_delete_role_groups
 *
 * Responses
 * - 200 - Returns a user
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User or Role Group does not exist
 *
 * Response {@link UsersUserWithSeparatedGroupsSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_role_groups__group_id__users__user_id__}
 */
export const httpDeleteRoleGroupsByGroupIdUsersByUserId = (
  groupId: string,
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteRoleGroupsByGroupIdUsersByUserId,
  method: httpMethod.delete,
  url: `/API/users/v1/role_groups/${encodeURIComponent(groupId)}/users/${encodeURIComponent(userId)}/`,
  params: { groupId, userId },
  headers,
});

/**
 * `POST /v1/role_groups/{group_id}/users/{user_id}/`
 *
 * Add user into a role group
 *
 * Required roles:
 *  - can_write_role_groups
 *
 * Responses
 * - 201 - Returns a user
 * - 401 - Token is invalid
 * - 404 - User or Role Group does not exist
 *
 * Response {@link UsersUserWithSeparatedGroupsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_role_groups__group_id__users__user_id__}
 */
export const httpPostRoleGroupsByGroupIdUsersByUserId = (
  groupId: string,
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostRoleGroupsByGroupIdUsersByUserId,
  method: httpMethod.post,
  url: `/API/users/v1/role_groups/${encodeURIComponent(groupId)}/users/${encodeURIComponent(userId)}/`,
  params: { groupId, userId },
  headers,
});

export interface UsersHttpGetTeamsQuery {
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc If omitted, results default to sorting by date_created,desc.
   */
  sort?: string;
  /**
   * Filter by alias
   */
  alias?: string;
  /**
   * Filter by descripton
   */
  description?: string;
  /**
   * Filter by name
   */
  name?: string;
  /**
   * Filter by date_created
   */
  date_created?: string;
  /**
   * Filter by date_modified
   */
  date_modified?: string;
  /**
   * Filter by any of field with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
}

/**
 * `GET /v1/teams/`
 *
 * List teams with details
 *
 * Required roles:
 *  - can_read_teams
 *
 * Responses
 * - 200 - Returns a list of teams
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link UsersTeamsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_teams_}
 */
export const httpGetTeams = (
  query?: UsersHttpGetTeamsQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetTeams,
  method: httpMethod.get,
  url: '/API/users/v1/teams/',

  query,
  headers,
});

/**
 * `POST /v1/teams/`
 *
 * Create a new team
 *
 * Required roles:
 *  - can_write_teams
 *
 * Responses
 * - 201 - Returns a created team
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link UsersTeamSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_teams_}
 */
export const httpPostTeams = (
  body: UsersTeamSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostTeams,
  method: httpMethod.post,
  url: '/API/users/v1/teams/',

  body,
  headers,
});

export interface UsersHttpGetTeamsBasicQuery {
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc If omitted, results default to sorting by date_created,desc.
   */
  sort?: string;
  /**
   * Filter by alias
   */
  alias?: string;
  /**
   * Filter by descripton
   */
  description?: string;
  /**
   * Filter by name
   */
  name?: string;
  /**
   * Filter by date_created
   */
  date_created?: string;
  /**
   * Filter by date_modified
   */
  date_modified?: string;
  /**
   * Filter by any of first_name, last_name and email with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
}

/**
 * `GET /v1/teams/basic/`
 *
 * List teams info without details
 *
 *
 * Responses
 * - 200 - Returns a list of teams
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Requested page does not exist
 *
 * Response {@link UsersGroupsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_teams_basic_}
 */
export const httpGetTeamsBasic = (
  query?: UsersHttpGetTeamsBasicQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetTeamsBasic,
  method: httpMethod.get,
  url: '/API/users/v1/teams/basic/',

  query,
  headers,
});

/**
 * `DELETE /v1/teams/{team_id}/`
 *
 * Delete a particular team by id
 *
 * Required roles:
 *  - can_delete_teams
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Team does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_teams__team_id__}
 */
export const httpDeleteTeamsByTeamId = (
  teamId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteTeamsByTeamId,
  method: httpMethod.delete,
  url: `/API/users/v1/teams/${encodeURIComponent(teamId)}/`,
  params: { teamId },
  headers,
});

/**
 * `GET /v1/teams/{team_id}/`
 *
 * Returns a particular team by id
 *
 * Required roles:
 *  - can_read_teams
 *
 * Responses
 * - 200 - Returns a team
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Team does not exist
 *
 * Response {@link UsersTeamSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_teams__team_id__}
 */
export const httpGetTeamsByTeamId = (
  teamId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetTeamsByTeamId,
  method: httpMethod.get,
  url: `/API/users/v1/teams/${encodeURIComponent(teamId)}/`,
  params: { teamId },
  headers,
});

export type UsersTeamSchemaPartial = Partial<UsersTeamSchema>;

/**
 * `PATCH /v1/teams/{team_id}/`
 *
 * Update team
 *
 * Required roles:
 *  - can_write_teams
 *
 * Responses
 * - 200 - Returns an updated team
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Team does not exist
 *
 * Response {@link UsersTeamSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/patch_v1_teams__team_id__}
 */
export const httpPatchTeamsByTeamId = (
  teamId: string,
  body: UsersTeamSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPatchTeamsByTeamId,
  method: httpMethod.patch,
  url: `/API/users/v1/teams/${encodeURIComponent(teamId)}/`,
  params: { teamId },
  body,
  headers,
});

/**
 * `PUT /v1/teams/{team_id}/`
 *
 * Update team
 *
 * Required roles:
 *  - can_write_teams
 *
 * Responses
 * - 200 - Returns an updated team
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Team does not exist
 *
 * Response {@link UsersTeamSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/put_v1_teams__team_id__}
 */
export const httpPutTeamsByTeamId = (
  teamId: string,
  body: UsersTeamSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPutTeamsByTeamId,
  method: httpMethod.put,
  url: `/API/users/v1/teams/${encodeURIComponent(teamId)}/`,
  params: { teamId },
  body,
  headers,
});

/**
 * `DELETE /v1/teams/{team_id}/logo/`
 *
 * Delete team logo image
 *
 * Required roles:
 *  - can_write_teams
 *
 * Responses
 * - 204 - No body
 * - 400 - Bad request
 * - 404 - Team does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_teams__team_id__logo_}
 */
export const httpDeleteTeamsByTeamIdLogo = (
  teamId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteTeamsByTeamIdLogo,
  method: httpMethod.delete,
  url: `/API/users/v1/teams/${encodeURIComponent(teamId)}/logo/`,
  params: { teamId },
  headers,
});

/**
 * Returns url for team logo
 */
export interface UsersHttpPostTeamsByTeamIdLogoResponse {
  /**
   * Url for the team logo
   */
  logo?: string;
}

/**
 * `POST /v1/teams/{team_id}/logo/`
 *
 * Upload team logo image
 *
 * Required roles:
 *  - can_write_teams
 *
 * Responses
 * - 200 - Returns url for team logo
 * - 400 - Bad request
 * - 404 - Team does not exist
 *
 * Response {@link UsersHttpPostTeamsByTeamIdLogoResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_teams__team_id__logo_}
 */
export const httpPostTeamsByTeamIdLogo = (
  teamId: string,
  formData: FormData,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostTeamsByTeamIdLogo,
  method: httpMethod.post,
  url: `/API/users/v1/teams/${encodeURIComponent(teamId)}/logo/`,
  params: { teamId },
  body: formData,
  headers,
});

/**
 * `DELETE /v1/teams/{team_id}/users/{user_id}/`
 *
 * Delete a user from team
 *
 * Required roles:
 *  - can_delete_teams
 *
 * Responses
 * - 200 - Returns a user
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User or Team does not exist
 *
 * Response {@link UsersUserWithSeparatedGroupsSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_teams__team_id__users__user_id__}
 */
export const httpDeleteTeamsByTeamIdUsersByUserId = (
  teamId: string,
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteTeamsByTeamIdUsersByUserId,
  method: httpMethod.delete,
  url: `/API/users/v1/teams/${encodeURIComponent(teamId)}/users/${encodeURIComponent(userId)}/`,
  params: { teamId, userId },
  headers,
});

/**
 * `POST /v1/teams/{team_id}/users/{user_id}/`
 *
 * Add user into a team
 *
 * Required roles:
 *  - can_write_teams
 *
 * Responses
 * - 201 - Returns a user
 * - 401 - Token is invalid
 * - 404 - User or Team does not exist
 *
 * Response {@link UsersUserWithSeparatedGroupsSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_teams__team_id__users__user_id__}
 */
export const httpPostTeamsByTeamIdUsersByUserId = (
  teamId: string,
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostTeamsByTeamIdUsersByUserId,
  method: httpMethod.post,
  url: `/API/users/v1/teams/${encodeURIComponent(teamId)}/users/${encodeURIComponent(userId)}/`,
  params: { teamId, userId },
  headers,
});

export interface UsersHttpGetUsersQuery {
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc If omitted, results default to sorting by date_created,desc.
   */
  sort?: string;
  /**
   * Filter by date_created
   */
  date_created?: string;
  /**
   * Filter by date_modified
   */
  date_modified?: string;
  /**
   * Filter by email
   */
  email?: string;
  /**
   * Filter by first_name
   */
  first_name?: string;
  /**
   * Filter by last_name
   */
  last_name?: string;
  /**
   * Filter by groups
   */
  groups?: string;
  /**
   * Filter by hide_email
   */
  hide_email?: string;
  /**
   * Filter by hide_phone
   */
  hide_phone?: string;
  /**
   * Filter by is_admin
   */
  is_admin?: string;
  /**
   * Filter by password_changed
   */
  password_changed?: string;
  /**
   * Filter by phone
   */
  phone?: string;
  /**
   * Filter by photo
   */
  photo?: string;
  /**
   * Filter by status
   */
  status?: string;
  /**
   * Filter by any of first_name, last_name and email with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
}

/**
 * `GET /v1/users/`
 *
 * List of users with details
 *
 * Required roles:
 *  - can_read_users
 *
 * Responses
 * - 200 - Returns a list of users
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Specified page does not exist
 *
 * Response {@link UsersUsersSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_users_}
 */
export const httpGetUsers = (
  query?: UsersHttpGetUsersQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetUsers,
  method: httpMethod.get,
  url: '/API/users/v1/users/',

  query,
  headers,
});

/**
 * `POST /v1/users/`
 *
 * Create a new user
 *
 * Required roles:
 *  - can_create_users
 *
 * Responses
 * - 201 - Returns a created user
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link UsersUserSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_users_}
 */
export const httpPostUsers = (
  body: UsersUserCreateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostUsers,
  method: httpMethod.post,
  url: '/API/users/v1/users/',

  body,
  headers,
});

export interface UsersHttpGetUsersBasicQuery {
  /**
   * Which page number to fetch
   */
  page?: number;
  /**
   * The number of items for each page
   */
  per_page?: number;
  /**
   * A comma separated list of fieldnames with order. For example - first_name,asc;last_name,desc If omitted, results default to sorting by date_created,desc.
   */
  sort?: string;
  /**
   * Filter by email
   */
  email?: string;
  /**
   * Filter by first_name
   */
  first_name?: string;
  /**
   * Filter by last_name
   */
  last_name?: string;
  /**
   * Filter by any of first_name, last_name and email with wildcard support
   */
  query?: string;
  /**
   * Filter list of id:s (comma separated)
   */
  ids?: string;
  /**
   * Filter by list of emails (comma separated)
   */
  emails?: string;
}

/**
 * `GET /v1/users/basic/`
 *
 * List of users without details
 *
 *
 * Responses
 * - 200 - Returns a list of users
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - Specified page does not exist
 *
 * Response {@link UsersUsersBasicSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_users_basic_}
 */
export const httpGetUsersBasic = (
  query?: UsersHttpGetUsersBasicQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetUsersBasic,
  method: httpMethod.get,
  url: '/API/users/v1/users/basic/',

  query,
  headers,
});

/**
 * `GET /v1/users/current/`
 *
 * Returns current user
 *
 *
 * Responses
 * - 200 - Returns a user
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * Response {@link UsersUserSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_users_current_}
 */
export const httpGetUsersCurrent = (headers?: IconikApiHeaders) => ({
  id: UsersHttpGetUsersCurrent,
  method: httpMethod.get,
  url: '/API/users/v1/users/current/',

  headers,
});

export type UsersUserSchemaPartial = Partial<UsersUserSchema>;

/**
 * `PATCH /v1/users/current/`
 *
 * Update user
 *
 *
 * Responses
 * - 200 - Returns an updated user
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * Response {@link UsersUserSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/patch_v1_users_current_}
 */
export const httpPatchUsersCurrent = (
  body: UsersUserSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPatchUsersCurrent,
  method: httpMethod.patch,
  url: '/API/users/v1/users/current/',

  body,
  headers,
});

/**
 * `PUT /v1/users/current/`
 *
 * Update user
 *
 *
 * Responses
 * - 200 - Returns an updated user
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * Response {@link UsersUserSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/put_v1_users_current_}
 */
export const httpPutUsersCurrent = (
  body: UsersUserSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPutUsersCurrent,
  method: httpMethod.put,
  url: '/API/users/v1/users/current/',

  body,
  headers,
});

/**
 * Current otp configuration
 */
export interface UsersHttpGetUsersCurrentOtpConfigureResponse {
  /**
   * mfa methods
   */
  mfa_methods?: ('MAIL_2SV' | 'TOTP')[];
  /**
   * is mfa required for the user
   */
  mfa_required?: boolean;
}

/**
 * `GET /v1/users/current/otp/configure/`
 *
 * Get current otp settings.
 *
 *
 * Responses
 * - 200 - Current otp configuration
 * - 400 - Bad request
 * - 401 - code is invalid
 *
 * Response {@link UsersHttpGetUsersCurrentOtpConfigureResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_users_current_otp_configure_}
 */
export const httpGetUsersCurrentOtpConfigure = (
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetUsersCurrentOtpConfigure,
  method: httpMethod.get,
  url: '/API/users/v1/users/current/otp/configure/',

  headers,
});

/**
 * `POST /v1/users/current/otp/configure/`
 *
 * Configure OTP settings.
 *
 *
 * Responses
 * - 200 - Successful verification
 * - 400 - Bad request
 * - 401 - code is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_users_current_otp_configure_}
 */
export const httpPostUsersCurrentOtpConfigure = (
  body: UsersOtpEditSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostUsersCurrentOtpConfigure,
  method: httpMethod.post,
  url: '/API/users/v1/users/current/otp/configure/',

  body,
  headers,
});

/**
 * `PUT /v1/users/current/otp/configure/`
 *
 * Configure OTP settings.
 *
 *
 * Responses
 * - 200 - Successful verification
 * - 400 - Bad request
 * - 401 - code is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/put_v1_users_current_otp_configure_}
 */
export const httpPutUsersCurrentOtpConfigure = (
  body: UsersOtpEditSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPutUsersCurrentOtpConfigure,
  method: httpMethod.put,
  url: '/API/users/v1/users/current/otp/configure/',

  body,
  headers,
});

/**
 * `DELETE /v1/users/current/photo/`
 *
 * Delete current user photo image.
 *
 *
 * Responses
 * - 204 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_users_current_photo_}
 */
export const httpDeleteUsersCurrentPhoto = (headers?: IconikApiHeaders) => ({
  id: UsersHttpDeleteUsersCurrentPhoto,
  method: httpMethod.delete,
  url: '/API/users/v1/users/current/photo/',

  headers,
});

/**
 * Returns url for user photo
 */
export interface UsersHttpPostUsersCurrentPhotoResponse {
  /**
   * Url for the user original photo
   */
  photo?: string;
  /**
   * Url for the user re-sized big photo
   */
  photo_big?: string;
  /**
   * Url for the user re-sized small photo
   */
  photo_small?: string;
}

/**
 * `POST /v1/users/current/photo/`
 *
 * Upload current user photo image.
 *
 *
 * Responses
 * - 201 - Returns url for user photo
 * - 400 - Bad request
 * - 404 - User does not exist
 *
 * Response {@link UsersHttpPostUsersCurrentPhotoResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_users_current_photo_}
 */
export const httpPostUsersCurrentPhoto = (
  formData: FormData,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostUsersCurrentPhoto,
  method: httpMethod.post,
  url: '/API/users/v1/users/current/photo/',

  body: formData,
  headers,
});

/**
 * `GET /v1/users/current/roles/`
 *
 * Returns current user roles
 *
 *
 * Responses
 * - 200 - Returns a user's roles
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link UsersUserRolesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_users_current_roles_}
 */
export const httpGetUsersCurrentRoles = (headers?: IconikApiHeaders) => ({
  id: UsersHttpGetUsersCurrentRoles,
  method: httpMethod.get,
  url: '/API/users/v1/users/current/roles/',

  headers,
});

/**
 * `DELETE /v1/users/current/totp/configure/`
 *
 * Delete totp confguration
 *
 *
 * Responses
 * - 200 - Configure TOTP
 * - 400 - Bad request
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_users_current_totp_configure_}
 */
export const httpDeleteUsersCurrentTotpConfigure = (
  body: UsersOtpSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteUsersCurrentTotpConfigure,
  method: httpMethod.delete,
  url: '/API/users/v1/users/current/totp/configure/',

  body,
  headers,
});

/**
 * Configure TOTP
 */
export interface UsersHttpPostUsersCurrentTotpConfigureResponse {
  /**
   * secret key
   */
  secret?: string;
  /**
   * provisioning URIs
   */
  url?: string;
}

/**
 * `POST /v1/users/current/totp/configure/`
 *
 * Setup totp
 *
 *
 * Responses
 * - 201 - Configure TOTP
 * - 400 - Bad request
 *
 * Response {@link UsersHttpPostUsersCurrentTotpConfigureResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_users_current_totp_configure_}
 */
export const httpPostUsersCurrentTotpConfigure = (
  body: UsersOtpSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostUsersCurrentTotpConfigure,
  method: httpMethod.post,
  url: '/API/users/v1/users/current/totp/configure/',

  body,
  headers,
});

/**
 * `POST /v1/users/current/totp/validate_configuration/`
 *
 * Validate totp configuration
 *
 *
 * Responses
 * - 200 - Successful verification
 * - 400 - Bad request
 * - 401 - code is invalid
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_users_current_totp_validate_configuration_}
 */
export const httpPostUsersCurrentTotpValidateConfiguration = (
  body: UsersOtpSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostUsersCurrentTotpValidateConfiguration,
  method: httpMethod.post,
  url: '/API/users/v1/users/current/totp/validate_configuration/',

  body,
  headers,
});

/**
 * `DELETE /v1/users/invite/purge/`
 *
 * Delete all invite links that were generated.
 *
 *
 * Responses
 * - 200 - Okay
 * - 400 - Bad Request
 * - 403 - Forbidden
 * - 404 - Not Found
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_users_invite_purge_}
 */
export const httpDeleteUsersInvitePurge = (headers?: IconikApiHeaders) => ({
  id: UsersHttpDeleteUsersInvitePurge,
  method: httpMethod.delete,
  url: '/API/users/v1/users/invite/purge/',

  headers,
});

/**
 * `POST /v1/users/invite/register/`
 *
 * Register a new user using an invite link token
 *
 *
 * Responses
 * - 201 - Returns the created user id with is_existing_user flag
 * - 400 - Bad request
 * - 409 - User already exists
 * - 429 - Too many requests
 *
 * Response {@link UsersUserInviteRegisterResponseSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_users_invite_register_}
 */
export const httpPostUsersInviteRegister = (
  body: UsersUserInviteRegisterRequestSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostUsersInviteRegister,
  method: httpMethod.post,
  url: '/API/users/v1/users/invite/register/',

  body,
  headers,
});

/**
 * Returns invite link
 */
export interface UsersHttpPostUsersInviteTokenRequestResponse {
  /**
   * The generated invite link
   */
  invite_link?: string;
}

/**
 * `POST /v1/users/invite/token/request/`
 *
 * Request an invite link for user invitation.
 *
 * Required roles:
 *  - can_create_users
 *
 * Responses
 * - 200 - Returns invite link
 * - 400 - Bad Request
 * - 403 - Forbidden
 * - 404 - Not Found
 *
 * Response {@link UsersHttpPostUsersInviteTokenRequestResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_users_invite_token_request_}
 */
export const httpPostUsersInviteTokenRequest = (
  body: UsersUserInviteRequestLinkSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostUsersInviteTokenRequest,
  method: httpMethod.post,
  url: '/API/users/v1/users/invite/token/request/',

  body,
  headers,
});

/**
 * Returns system domain name
 */
export interface UsersHttpPostUsersInviteValidateResponse {
  /**
   * The system domain name
   */
  system_domain_name?: string;
}

export interface UsersHttpPostUsersInviteValidateQuery {
  /**
   * The invite link hash to validate
   */
  hash: string;
}

/**
 * `POST /v1/users/invite/validate/`
 *
 * Validate an invite link for user invitation.
 *
 *
 * Responses
 * - 200 - Returns system domain name
 * - 400 - Bad Request
 *
 * Response {@link UsersHttpPostUsersInviteValidateResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_users_invite_validate_}
 */
export const httpPostUsersInviteValidate = (
  query?: UsersHttpPostUsersInviteValidateQuery,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostUsersInviteValidate,
  method: httpMethod.post,
  url: '/API/users/v1/users/invite/validate/',

  query,
  headers,
});

/**
 * `DELETE /v1/users/partner_domain_access/`
 *
 * Remove customer domain access from all users in a partner domain.
 *
 * (Super admins only)
 *
 * Responses
 * - 202 - Access removed
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_users_partner_domain_access_}
 */
export const httpDeleteUsersPartnerDomainAccess = (
  body: UsersPartnerDomainAccessSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteUsersPartnerDomainAccess,
  method: httpMethod.delete,
  url: '/API/users/v1/users/partner_domain_access/',

  body,
  headers,
});

/**
 * `POST /v1/users/partner_domain_access/`
 *
 * Grant all owner users in a partner domain access to a customer domain.
 *
 * (Super admins only)
 *
 * Responses
 * - 202 - Access granted
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 403 - Forbidden
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_users_partner_domain_access_}
 */
export const httpPostUsersPartnerDomainAccess = (
  body: UsersPartnerDomainAccessSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostUsersPartnerDomainAccess,
  method: httpMethod.post,
  url: '/API/users/v1/users/partner_domain_access/',

  body,
  headers,
});

/**
 * `DELETE /v1/users/{user_id}/`
 *
 * Delete a particular user by id
 *
 * Required roles:
 *  - can_delete_users
 *
 * Responses
 * - 204 - Without body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_users__user_id__}
 */
export const httpDeleteUsersByUserId = (
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteUsersByUserId,
  method: httpMethod.delete,
  url: `/API/users/v1/users/${encodeURIComponent(userId)}/`,
  params: { userId },
  headers,
});

/**
 * `GET /v1/users/{user_id}/`
 *
 * Returns a particular user by id
 *
 * Required roles:
 *  - can_read_users
 *
 * Responses
 * - 200 - Returns a user
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * Response {@link UsersUserWithSeparatedGroupsSchemaWithIdNullable}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_users__user_id__}
 */
export const httpGetUsersByUserId = (
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetUsersByUserId,
  method: httpMethod.get,
  url: `/API/users/v1/users/${encodeURIComponent(userId)}/`,
  params: { userId },
  headers,
});

/**
 * `PATCH /v1/users/{user_id}/`
 *
 * Update user
 *
 * Required roles:
 *  - can_write_users
 *
 * Responses
 * - 200 - Returns an updated user
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * Response {@link UsersUserSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/patch_v1_users__user_id__}
 */
export const httpPatchUsersByUserId = (
  userId: string,
  body: UsersUserSchemaPartial,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPatchUsersByUserId,
  method: httpMethod.patch,
  url: `/API/users/v1/users/${encodeURIComponent(userId)}/`,
  params: { userId },
  body,
  headers,
});

/**
 * `PUT /v1/users/{user_id}/`
 *
 * Update user
 *
 * Required roles:
 *  - can_write_users
 *
 * Responses
 * - 200 - Returns an updated user
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * Response {@link UsersUserSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/put_v1_users__user_id__}
 */
export const httpPutUsersByUserId = (
  userId: string,
  body: UsersUserSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPutUsersByUserId,
  method: httpMethod.put,
  url: `/API/users/v1/users/${encodeURIComponent(userId)}/`,
  params: { userId },
  body,
  headers,
});

/**
 * `DELETE /v1/users/{user_id}/photo/`
 *
 * Delete a photo image of a specified user.
 *
 * Required roles:
 *  - can_write_users
 *
 * Responses
 * - 204 - No body
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_users__user_id__photo_}
 */
export const httpDeleteUsersByUserIdPhoto = (
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteUsersByUserIdPhoto,
  method: httpMethod.delete,
  url: `/API/users/v1/users/${encodeURIComponent(userId)}/photo/`,
  params: { userId },
  headers,
});

/**
 * Returns url for user photo
 */
export interface UsersHttpPostUsersByUserIdPhotoResponse {
  /**
   * Url for the user original photo
   */
  photo?: string;
  /**
   * Url for the user re-sized big photo
   */
  photo_big?: string;
  /**
   * Url for the user re-sized small photo
   */
  photo_small?: string;
}

/**
 * `POST /v1/users/{user_id}/photo/`
 *
 * Upload user photo image.
 *
 * Required roles:
 *  - can_write_users
 *
 * Responses
 * - 201 - Returns url for user photo
 * - 400 - Bad request
 * - 404 - User does not exist
 *
 * Response {@link UsersHttpPostUsersByUserIdPhotoResponse}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_users__user_id__photo_}
 */
export const httpPostUsersByUserIdPhoto = (
  userId: string,
  formData: FormData,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostUsersByUserIdPhoto,
  method: httpMethod.post,
  url: `/API/users/v1/users/${encodeURIComponent(userId)}/photo/`,
  params: { userId },
  body: formData,
  headers,
});

/**
 * `POST /v1/users/{user_id}/reindex/`
 *
 * Reindex a particular user by id
 *
 * Required roles:
 *  - can_reindex_users
 *
 * Responses
 * - 200 - Returns a job
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * Response {@link UsersUserSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/post_v1_users__user_id__reindex_}
 */
export const httpPostUsersByUserIdReindex = (
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPostUsersByUserIdReindex,
  method: httpMethod.post,
  url: `/API/users/v1/users/${encodeURIComponent(userId)}/reindex/`,
  params: { userId },
  headers,
});

/**
 * `GET /v1/users/{user_id}/roles/`
 *
 * Returns user roles by user_id
 *
 * Required roles:
 *  - can_read_users
 *
 * Responses
 * - 200 - Returns a user's roles
 * - 400 - Bad request
 * - 401 - Token is invalid
 *
 * Response {@link UsersUserRolesSchemaWithId}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_users__user_id__roles_}
 */
export const httpGetUsersByUserIdRoles = (
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetUsersByUserIdRoles,
  method: httpMethod.get,
  url: `/API/users/v1/users/${encodeURIComponent(userId)}/roles/`,
  params: { userId },
  headers,
});

/**
 * `GET /v1/users/{user_id}/roles/{role}/`
 *
 * Returns user roles by user_id
 *
 * Required roles:
 *  - can_read_users
 *
 * Responses
 * - 200 - Returns 200 if user has role
 * - 401 - Token is invalid
 * - 404 - Returns 404 if user doesn't have role
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_users__user_id__roles__role__}
 */
export const httpGetUsersByUserIdRolesByRole = (
  userId: string,
  role: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpGetUsersByUserIdRolesByRole,
  method: httpMethod.get,
  url: `/API/users/v1/users/${encodeURIComponent(userId)}/roles/${encodeURIComponent(role)}/`,
  params: { userId, role },
  headers,
});

/**
 * `DELETE /v1/users/{user_id}/saml/`
 *
 * Remove a user's SAML IdP setting
 *
 *
 * Responses
 * - 200 - Returns an updated user
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * Response {@link UsersUserSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/delete_v1_users__user_id__saml_}
 */
export const httpDeleteUsersByUserIdSaml = (
  userId: string,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpDeleteUsersByUserIdSaml,
  method: httpMethod.delete,
  url: `/API/users/v1/users/${encodeURIComponent(userId)}/saml/`,
  params: { userId },
  headers,
});

/**
 * `PUT /v1/users/{user_id}/saml/`
 *
 * Update a user's SAML IdP settings
 *
 *
 * Responses
 * - 200 - Returns an updated user
 * - 400 - Bad request
 * - 401 - Token is invalid
 * - 404 - User does not exist
 *
 * Response {@link UsersUserSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/put_v1_users__user_id__saml_}
 */
export const httpPutUsersByUserIdSaml = (
  userId: string,
  body: UsersUserSamlIdpUpdateSchema,
  headers?: IconikApiHeaders,
) => ({
  id: UsersHttpPutUsersByUserIdSaml,
  method: httpMethod.put,
  url: `/API/users/v1/users/${encodeURIComponent(userId)}/saml/`,
  params: { userId },
  body,
  headers,
});

/**
 * `GET /v1/roles/`
 *
 * Returns all roles
 *
 *
 * Responses
 * - 200 - Returns all roles
 *
 * Response {@link UsersAllRolesSchema}
 *
 * [Documentation]{@link https://test.iconik.cloud/docs/apidocs.html?url=/docs/users/spec/#/default/get_v1_roles_}
 */
export const httpGetRoles = (headers?: IconikApiHeaders) => ({
  id: UsersHttpGetRoles,
  method: httpMethod.get,
  url: '/API/users/v1/roles/',

  headers,
});
